<template>
  <v-card elevation="0">
    <v-layout v-if="type !== 'target'" justify-center pt-2>
      <div class="grey--text">{{ label }}</div>
    </v-layout>

    <v-flex xs12 v-if="!hasMedia">
      <div>
        <input
          v-if="access.includes('audio')"
          type="file"
          ref="file"
          :id="id"
          :accept="accept"
          class="hide"
          @change="handleFileUpload"
        />
        <slot name="upload-label"></slot>
      </div>
      <label :for="id" slot="upload-label">
        <v-layout :class="['MediaInput__emptyField']">
          <div @click="checkMediaAccess" :style="componentStyleWidth">
            <v-icon v-if="!isUploading" large color="primary">mdi-music</v-icon>
            <v-icon
              v-if="!isUploading && access.includes('video')"
              large
              color="primary"
              >mdi-video</v-icon
            >
            <!--v-icon 
            v-if="!isUploading"
            small color="yellow darken-2">
            mdi-star
            </v-icon-->
          </div>
        </v-layout>
      </label>
      <v-flex layout justify-center align-center v-if="showError">
        <p class="ruleText">
          <span>{{ showError }} </span>
        </p>
      </v-flex>
    </v-flex>

    <v-layout v-if="hasMedia" pt-2 class="showEdit">
      <v-img
        v-if="hasMedia"
        class="MediaInput__image"
        :src="imageDisplay"
        :lazy-src="soundWaveImage"
        :height="60"
        :width="width"
        :max-width="350"
      />
    </v-layout>
    <v-card
      v-if="hasMedia"
      class="banner hide"
      elevation="0"
      color="rgba(230,230,230,0.7)"
    >
      <v-flex layout justify-center>
        <div>
          <input
            type="file"
            ref="file"
            :id="id"
            :accept="accept"
            class="hide"
            @change="handleFileUpload"
          />
          <slot name="upload-label"></slot>
        </div>
        <label :for="id" slot="upload-label">
          <v-icon medium color="primary" class="pointerClass"
            >mdi-pencil</v-icon
          >
        </label>
        <v-icon medium color="red" @click="deleteMedia"> mdi-close</v-icon>
      </v-flex>
    </v-card>
    <v-flex layout justify-center class="grey--text">{{ name }}</v-flex>

    <premium-dialog
      v-if="openPremiumDialog"
      :isTextDialogOpen="openPremiumDialog"
      :title="premiumTitle"
      @confirm="closePremium()"
      @cancel="closePremium()"
    >
    </premium-dialog>
  </v-card>
</template>

<script>
import axios from 'axios';
import PremiumDialog from './PremiumDialog';

export default {
  name: 'MediaInput',
  components: {
    PremiumDialog,
  },
  data: () => ({
    file: {},
    soundWaveImage:
      'https://s3.eu-west-3.amazonaws.com/explorama-dev/contentPictures/054ce856-a533-4b4c-b357-6872176baf26-sound-wave1_etire.png',
    //'https://s3.eu-west-3.amazonaws.com/explorama-dev/contentPictures/57281a89-92d0-4893-9610-5fd0eff2bda8.jpg',
    videoImage:
      'https://s3.eu-west-3.amazonaws.com/explorama-dev/contentPictures/0e8865b8-9785-4f55-9060-640c893faae9.jpg',
    mediaUrl: null,
    imageDisplay: null,
    maxAudioSize: 5000000, //5Mb
    maxVideoSize: 20000000, //20Mb
    isUploading: false,
    showError: null,
    accept: ['audio', 'video'],
    id:
      'fileInput_' +
      Math.random()
        .toString(36)
        .replace(/[^a-z]+/g, '')
        .substr(0, 5),
    openPremiumDialog: false,
  }),
  props: {
    label: {
      type: String,
      default: null,
    },
    tooltip: String,
    default: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    //accept: {
    //  type: String,
    //  default: 'audio/mpeg',
    //},
    width: {
      type: Number,
      default: 350,
    },
  },
  created() {
    this.mediaUrl = this.default;
    if (this.mediaUrl) {
      this.file = new File(['foo'], this.name, { type: 'audio/mpeg' });
    }
    if (this.type === 'video/mp4') {
      this.imageDisplay = this.videoImage;
    } else if (this.type === 'audio/mpeg') {
      this.imageDisplay = this.soundWaveImage;
    }
  },

  computed: {
    accountId() {
      return this.$store.getters['accounts/currentAccount']._kuzzle_info
        .accountId;
    },
    componentStyleWidth() {
      return `width:${this.width}px`;
    },
    hasMedia() {
      if (this.mediaUrl === Object) {
        return this.mediaUrl && this.mediaUrl.url.length > 0;
      }
      return this.mediaUrl && this.mediaUrl.length > 0;
    },
    // offer() {
    //   return this.$store.getters['accounts/currentAccount'].offer || {};
    // },
    access() {
      return (
        this.$store.getters['paths/getPathsAccess'][
          this.$route.params.pathId
        ] || []
      );
    },
    premiumTitle() {
      return this.$t('premiumDialog.title.media');
    },
  },
  methods: {
    fileSizeCheck() {
      if (this.file.type.split('/')[0] === 'audio') {
        return this.file.size < this.maxAudioSize;
      }
      return this.file.size < this.maxVideoSize;
    },
    fileTypeCheck() {
      return this.accept.includes(this.file.type.split('/')[0]);
    },
    async handleFileUpload() {
      console.log('file', this.$refs.file);

      this.file = this.$refs.file.files[0];
      console.log('file type', this.file.type, this.file.type.split('/')[0]);
      if (!this.fileSizeCheck()) {
        if (this.file.type.split('/')[0] === 'audio') {
          this.showError = this.$tc(
            'media.error.fileTooBig',
            this.maxAudioSize / 1000000
          );
        } else {
          this.showError = this.$tc(
            'media.error.fileTooBig',
            this.maxVideoSize / 1000000
          );
        }
        return;
      }
      if (!this.fileTypeCheck()) {
        this.showError = this.$t('media.error.fileTypeError');
        return;
      }

      if (this.file.type.includes('audio')) {
        this.imageDisplay = this.soundWaveImage;
      } else if (
        this.file.type.includes('video') ||
        this.file.type.split('/')[0] === 'video'
      ) {
        this.imageDisplay = this.videoImage;
      } else {
        this.imageDisplay = null;
      }
      this.showError = null;
      try {
        const { result } = await this.$kuzzle.query({
          controller: 'explorama-plugin/s3',
          action: 'getUploadUrlStudio',
          uploadDir: 'contentPictures',
          accountId: this.accountId.split('-')[0],
          fileext: this.file.name.split('.').pop(),
        });

        console.log('EMIT change media input');
        this.$emit('change-media-input', {
          url: result.fileUrl,
          name: this.file.name,
          type: this.file.type,
        });
        this.mediaUrl = result.fileUrl;
        console.log('file url', result.fileUrl);

        this.isUploading = true;
        await this.upload(this.file, result.uploadUrl);
        this.isUploading = false;
        this.$emit('uploading-media', this.isUploading);
      } catch (error) {
        this.$emit('error', error);
      }
    },
    onUploadProgress(event) {
      const percentProgress = Math.round((event.loaded * 100) / event.total);
      this.$emit('uploading-media', this.isUploading, percentProgress);
    },
    async upload(file, uploadUrl) {
      const blob = new Blob([file], { type: this.file.type });
      const newfile = new File([blob], this.file.name, {
        type: this.file.type,
      });
      //let formData = new FormData();
      //formData.append('file', blob, this.file.name);

      const axiosOptions = {
        onUploadProgress: (progressEvent) =>
          this.onUploadProgress(progressEvent),
        headers: {
          'Content-Type': this.file.type,
        },
      };
      try {
        const result = await axios.put(uploadUrl, newfile, axiosOptions);
      } catch (error) {
        console.error(error);
      } finally {
        console.log('Upload complete');
      }
    },
    deleteMedia() {
      this.$emit('change-media-input', {
        url: '',
        name: '',
        type: '',
      });
      this.mediaUrl = null;
    },
    closePremium() {
      this.openPremiumDialog = false;
    },
    checkMediaAccess() {
      if (!this.access.includes('audio')) {
        this.openPremiumDialog = true;
      }
    },
  },
  watch: {
    default(newValue) {
      this.mediaUrl = newValue;
      return newValue;
    },
  },
};
</script>

<style scoped lang="sass">

.MediaInput__emptyField
  background: white
  cursor: pointer
  display: flex
  align-items: center
  justify-content: center
  border-radius: 4px

  div
    height: 40px
    border: 2px dashed #009999
    border-radius: 2px
    display: flex
    justify-content: center
    align-items: center


.MediaInput__image
	pointer-events: none

.MediaInput__close
  position: absolute
  top: -12px
  left: -12px
  cursor: pointer

.MediaInput__wrapper
  position: relative
  border-radius: 4px

.hide
  display: none

.showEdit
  justify-content: center

.showEdit:hover + .hide
  display: block
  position: absolute
  over
  z-index: 10

.banner:hover
  display: block
  position: absolute
  over
  z-index: 10

.banner
  position: absolute
  top : 60%
  left: 50%
  transform: translate(-50%, -50%);
  width: 100%;
  color: rgba(0,0,0,0.3)

.pointerClass
  cursor: pointer

.ruleText
  color: red;
  font-size: small;
  text-align: center;
  line-height: 120%;
  margin-top: 10px;
</style>
